import { FIELD_MAP } from './columnDefinitions'

const WroId = 'WroId'
const InsertDate = 'CreationDate'
const FulfillmentCenter = 'FulfillmentCenter'
const ReturnId = 'ReturnId'
const LastUpdatedDate = 'LastUpdatedDate'

export const DESCENDING = 'desc'
export const ASCENDING = 'asc'

const fieldToUrlMap = {
  [FIELD_MAP.Id]: WroId,
  [FIELD_MAP.CreationDate]: InsertDate,
  [FIELD_MAP.FulfillmentCenter]: FulfillmentCenter,
  [FIELD_MAP.ReturnId]: ReturnId,
  [FIELD_MAP.LastUpdatedDate]: LastUpdatedDate
}
export const FieldToUrlMap = (field) => fieldToUrlMap[field]
export const UrlToFieldMap = (url) => Object.keys(fieldToUrlMap).find(key => fieldToUrlMap[key] === url)

export const DefaultSortField = FIELD_MAP.Id
export const DefaultSortOrderingDescending = true

export default {
  [FIELD_MAP.Id]: 'RequestId',
  [FIELD_MAP.CreationDate]: 'InsertDate',
  [FIELD_MAP.FulfillmentCenter]: 'FulfillmentCenterName',
  [FIELD_MAP.ReturnId]: 'ReturnId',
  [FIELD_MAP.LastUpdatedDate]: 'LastUpdatedDate'
}
